import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { getPartnerPermissions } from 'selectors/entities'
import { getPathname } from 'selectors/common'
import { TYPE_LINK, TYPE_SEPARATOR, TYPE_ADD_EVENT, TYPE_WITH_CHILDREN } from 'constants/navigation-constants'
import { getFeatureFlag } from 'selectors/settings'
import Navigation from './navigation'

export class NavigationContainer extends Component {

  render() {
    const { partner, pathName } = this.props
    const baseLink = `/p/${partner.id}`

    let navigationItems = [{
      type: TYPE_LINK,
      label: 'Events',
      path: baseLink,
      match: /\/p\/\d+(\/(event|performance).*?)?\/?$/g,
    }]

    if (this.props.canSeeFinancials) {
      navigationItems = [...navigationItems,
        {
          type: TYPE_LINK,
          label: 'Payments',
          path: `${baseLink}/payments`,
          match: /\/p\/\d+\/payments\/?$/g,
        },
      ]
    }

    if (this.props.canSeePartnerPageConfig) {
      navigationItems = [...navigationItems,
        {
          type: TYPE_LINK,
          label: 'Design',
          path: `${baseLink}/page_config`,
          match: /\/p\/\d+\/page_config\/?$/g,
        },
      ]
    }

    if (this.props.canSeeDataPage) {
      navigationItems = [...navigationItems,
        {
          type: TYPE_LINK,
          label: 'Reporting',
          path: `${baseLink}/data`,
          match: /\/p\/\d+\/data\/?$/g,
        },
      ]
    }

    navigationItems = [...navigationItems,
      {
        type: TYPE_SEPARATOR,
      },
      {
        type: TYPE_LINK,
        label: 'Drafts',
        path: `${baseLink}/drafts`,
        match: /\/p\/\d+\/drafts\/?$/g,
      },
    ]

    if (this.props.canAddEvents) {
      if (this.props.nonDatedEventFeature) {
        navigationItems = [
          ...navigationItems,
          {
            label: 'Create new +',
            type: TYPE_WITH_CHILDREN,
            subitems: [
              {
                type: TYPE_ADD_EVENT,
                label: 'Event',
                path: `${baseLink}/sf/new`,
                match: /\/sf\/new/g,
                external: true,
              },
              {
                type: TYPE_ADD_EVENT,
                label: 'Voucher',
                path: `${baseLink}/sf/new/voucher/`,
                match: /\/sf\/new\/voucher/g,
                external: true,
              },
            ]
          },
        ]
      } else {
        navigationItems = [
          ...navigationItems,
          {
            type: TYPE_ADD_EVENT,
            label: 'Create an event +',
            path: `${baseLink}/sf/new`,
            match: /.*/g,
            external: true,
          },
        ]
      }
    }

    return (
      <Navigation items={navigationItems} pathName={pathName} />
    )
  }

}

NavigationContainer.propTypes = {
  canAddEvents: PropTypes.bool,
  canSeeDataPage: PropTypes.bool,
  canSeeFinancials: PropTypes.bool,
  canSeePartnerPageConfig: PropTypes.bool,
  nonDatedEventFeature: PropTypes.bool,
  partner: PropTypes.object,
  pathName: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => ({
  pathName: getPathname(state),
  canAddEvents: getPartnerPermissions(ownProps.partner.id)(state).canAddEvents,
  canSeeDataPage: getPartnerPermissions(ownProps.partner.id)(state).canSeeDataPage,
  canSeeFinancials: getPartnerPermissions(ownProps.partner.id)(state).canSeeFinancials,
  canSeePartnerPageConfig: getPartnerPermissions(ownProps.partner.id)(state).canSeePartnerPageConfig,
  nonDatedEventFeature: getFeatureFlag('portal_non_date_event')(state),
})

export default connect(mapStateToProps)(NavigationContainer)



/** WEBPACK FOOTER **
 ** ./src/components/navigation/navigation-container.js
 **/